import { render, staticRenderFns } from "./RegularizationModal.vue?vue&type=template&id=3c5b45a2&scoped=true&"
import script from "./RegularizationModal.vue?vue&type=script&lang=js&"
export * from "./RegularizationModal.vue?vue&type=script&lang=js&"
import style0 from "./RegularizationModal.vue?vue&type=style&index=0&id=3c5b45a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b45a2",
  null
  
)

export default component.exports